import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-text-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-text-block-editor.html',
})
export class LandingPageTextBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  updateTextContent(value: string): void {
    this.blockChange.emit({ textContent: value });
  }
}
